import { render, staticRenderFns } from "./CreationView.vue?vue&type=template&id=3be03426&"
import script from "./CreationView.vue?vue&type=script&lang=js&"
export * from "./CreationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports